import { configuredAsyncComponentLoader } from '../utils/loader'
import { Pages, Routes } from './types'

const routes: Routes = {
  [Pages.NotFound]: {
    component: configuredAsyncComponentLoader(() => import('pages/NotFound')),
    path: '*',
  },
  [Pages.Login]: {
    component: configuredAsyncComponentLoader(() => import('pages/login')),
    path: '/login',
    title: 'login',
  },
  [Pages.PanDetail]: {
    component: configuredAsyncComponentLoader(() => import('pages/PanDetails')),
    path: '/PanDetails',
    title: 'Pan Details',
  },
  [Pages.Home]: {
    component: configuredAsyncComponentLoader(() => import('pages/home')),
    path: '/',
    title: 'Home',
  },
  [Pages.CreateLead]: {
    component: configuredAsyncComponentLoader(() => import('pages/createlead')),
    path: '/CreateLead',
    title: 'Create Lead',
  },
  [Pages.CreateOpportunity]: {
    component: configuredAsyncComponentLoader(() => import('pages/Opportunity/OpportunityList')),
    path: '/CreateOpportunity',
    title: 'Create Opportunity',
  },
  [Pages.BusinessDetails]: {
    component: configuredAsyncComponentLoader(() => import('pages/businessdetails')),
    path: '/BusinessDetails',
    title: 'Business Details',
  },
  [Pages.MultiStores]: {
    component: configuredAsyncComponentLoader(() => import('pages/MultiStores/MultiStores')),
    path: '/MultiStore',
    title: 'Multi Stroes',
  },
  [Pages.BankAccount]: {
    component: configuredAsyncComponentLoader(() => import('pages/bankaccount')),
    path: '/BankAccount',
    title: 'Bank account',
  },
  [Pages.CapturePhoto]: {
    component: configuredAsyncComponentLoader(() => import('pages/capturephoto')),
    path: '/CapturePhoto',
    title: 'Capture photos',
  },
  [Pages.KycDetails]: {
    component: configuredAsyncComponentLoader(() => import('pages/kyc/components/ReviewKyc')),
    path: '/kycDetails',
    title: 'KYC Details',
  },
  [Pages.Products]: {
    component: configuredAsyncComponentLoader(() => import('pages/product/ProductListing')),
    path: '/products',
    title: 'Select Products',
  },
  [Pages.LeadsListing]: {
    component: configuredAsyncComponentLoader(() => import('pages/home/LeadsListing')),
    path: '/leads',
    title: 'Leads',
  },
  [Pages.VasListing]: {
    component: configuredAsyncComponentLoader(() => import('pages/vas/VasListing')),
    path: '/Vas',
    title: 'Vas',
  },
  [Pages.ReviewDetails]: {
    component: configuredAsyncComponentLoader(() => import('pages/review/ReviewAllDetails')),
    path: '/ReviewDetails',
    title: 'ReviewDetails',
  },
  // [Pages.PricingPlan]: {
  //   component: configuredAsyncComponentLoader(() => import('pages/ProductsCatalog')),
  //   path: '/PricingPlan/*',
  //   title: 'Pricing Plan',
  // },
  [Pages.PricingPlan]: {
    component: configuredAsyncComponentLoader(() => import('pages/mdrProduct')),
    path: '/PricingPlan',
    title: 'Pricing Plan',
  },
  [Pages.ProductReview]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/ProductsCatalog/components/ProductSummary'),
    ),
    path: '/productsSummary/',
    title: 'Product Summary',
  },

  [Pages.POPayment]: {
    component: configuredAsyncComponentLoader(() => import('pages/payment/POPayment')),
    path: '/PO',
    title: 'Payment',
  },
  [Pages.NachMandate]: {
    component: configuredAsyncComponentLoader(() => import('pages/nach/NachMandate')),
    path: '/NachMandate',
    title: 'NACH mandate',
  },
  [Pages.NachMandateStatus]: {
    component: configuredAsyncComponentLoader(() => import('pages/nach/NachMandateStatus')),
    path: '/NachMandateStatus',
    title: 'NACH mandate',
  },
  [Pages.PurchaseOrder]: {
    component: configuredAsyncComponentLoader(() => import('pages/po/PurchaseOrder')),
    path: '/PurchaseOrder',
    title: 'Purchase Order',
  },
  [Pages.NachDocumentUpload]: {
    component: configuredAsyncComponentLoader(() => import('pages/nach/NachDocumentUpload')),
    path: '/NachDocumentUpload',
    title: 'Nach mandate',
  },
  [Pages.NachLotusStatus]: {
    component: configuredAsyncComponentLoader(() => import('pages/nach/NachLotusStatus')),
    path: '/NachLotusStatus',
    title: 'Nach Lotus Status',
  },
  [Pages.Deployment]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/deployment_multi/DeploymentMultiStore'),
    ),
    path: '/Deployment',
    title: 'Deployment',
  },
  [Pages.Deployments]: {
    component: configuredAsyncComponentLoader(() => import('pages/DeploymentFlow/Deployments')),
    path: '/deployments',
    title: 'Deployments',
  },
  [Pages.PricingLWC]: {
    component: configuredAsyncComponentLoader(() => import('pages/product/PricingLWC')),
    path: '/ProductLWC',
    title: 'Pricing',
  },
  [Pages.DeploymentMulti]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/deployment_multi/DeploymentMultiStore'),
    ),
    path: '/deploymentMulti',
    title: 'Deployment',
  },
  [Pages.OtherBusinessDoc]: {
    component: configuredAsyncComponentLoader(() => import('pages/otherdocument/OtherBusinessDoc')),
    path: '/otherbusinessdoc',
    title: 'Other Busineess Doc',
  },
  [Pages.PartnershipKyc]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/kyc/components/PartnershipKycManagement'),
    ),
    path: '/partnershipKyc',
    title: 'Partner ship kyc',
  },
  [Pages.FAQScreen]: {
    component: configuredAsyncComponentLoader(() => import('pages/faq/FAQScreen')),
    path: '/faq',
    title: 'FAQ',
  },
  [Pages.AllFAQSection]: {
    component: configuredAsyncComponentLoader(() => import('pages/faq/AllFAQSection')),
    path: '/AllFAQSection',
    title: 'FAQ',
  },
  [Pages.YoutubePlayer]: {
    component: configuredAsyncComponentLoader(() => import('pages/faq/YoutubePlayer')),
    path: '/player',
    title: 'FAQ',
  },
  [Pages.LiveDevices]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/deployment_multi/LiveDeviceListPage'),
    ),
    path: '/livedevices',
    title: 'Live Devices',
  },
  [Pages.LiveDeviceDetails]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/deployment_multi/LiveDeviceDetail'),
    ),
    path: '/deviceDetail',
    title: 'Device Detail',
  },
  [Pages.CompleteDeploment]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/DeploymentFlow/CompleteDeploment/completeDeploment'),
    ),
    path: '/deploymentMulti/completeDeployment',
    title: 'Complete Deployment',
  },
  [Pages.LinkPaymentDevices]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/DeploymentFlow/CompleteDeploment/linkPaymentDevices'),
    ),
    path: '/deploymentMulti/linkPaymentDevices',
    title: 'Map Other QR Codes',
  },
  [Pages.MapDevices]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/DeploymentFlow/CompleteDeploment/mapDevices'),
    ),
    path: '/deploymentMulti/mapDevices',
    title: 'Map Devices',
  },
  [Pages.TestTransactions]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/DeploymentFlow/CompleteDeploment/testTransactions'),
    ),
    path: '/deploymentMulti/testTransactions',
    title: 'Test Transactions',
  },
  [Pages.ClosureRemarks]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/DeploymentFlow/CompleteDeploment/closureRemarks'),
    ),
    path: '/closureRemarks',
    title: 'Closure Remarks',
  },
  [Pages.InventoryManagement]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/inventoryManagement/InventoryManagement'),
    ),
    path: '/inventoryManagement',
    title: 'Inventory Management',
  },
  [Pages.MyAttendance]: {
    component: configuredAsyncComponentLoader(() => import('pages/attendance/MyAttendance')),
    path: '/my-attendance',
    title: 'My Attendance',
  },
  [Pages.Notifications]: {
    component: configuredAsyncComponentLoader(() => import('pages/notifications/Notifications')),
    path: '/notifications',
    title: 'Notifications',
  },
  [Pages.LeadNotification]: {
    component: configuredAsyncComponentLoader(() => import('pages/notifications/LeadNotification')),
    path: '/notification/lead/:leadId',
    title: 'Lead',
  },
  [Pages.RevisitFeedback]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/feedback')),
    path: '/revisit/feedback',
    title: 'Feedback',
  },
  [Pages.RevisitMerchantDetails]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/merchant_details')),
    path: '/revisit/merchant-details',
    title: 'Merchant Details',
  },
  [Pages.RevisitComplete]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/complete')),
    path: '/revisit/complete',
    title: 'Complete',
  },
  [Pages.RevisitConfirmLocation]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/revisit/confirm_merchant_location'),
    ),
    path: '/revisit/confirm-location',
    title: 'Confirm Location',
  },
  [Pages.RevisitConfirmOTP]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/confirm_otp')),
    path: '/revisit/confirm-otp',
    title: 'Confirm OTP',
  },
  [Pages.RevisitShopForm]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/shopform')),
    path: '/revisit/shopform',
    title: 'Shop Form',
  },
  [Pages.RevisitPhotos]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/revisit/visit_photo/CaptureVisitPhoto'),
    ),
    path: '/revisit/photos',
    title: 'Capture Photos',
  },
  [Pages.RevisitMapQR]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/map_qr/RevisitMapQR')),
    path: '/revisit/map-qr',
    title: 'Map QR',
  },
  [Pages.RevisitLoading]: {
    component: configuredAsyncComponentLoader(() => import('pages/revisit/loading/RevisitLoading')),
    path: '/revisit/loading',
    title: 'Loading',
  },
  [Pages.MdrProduct]: {
    component: configuredAsyncComponentLoader(() => import('pages/mdrProduct')),
    path: '/mdrProduct',
    title: 'MDR Plans',
  },
  [Pages.ProductDetail]: {
    component: configuredAsyncComponentLoader(() => import('pages/mdrProduct/productDetail')),
    path: '/PricingPlan/productDetail/',
    title: 'Product Detail',
  },
  [Pages.PreviewOrder]: {
    component: configuredAsyncComponentLoader(() => import('pages/mdrProduct/previewOrder')),
    path: '/PricingPlan/previewOrder',
    title: 'Preview Order',
  },
  [Pages.CaptureShopPhoto]: {
    component: configuredAsyncComponentLoader(() => import('pages/capturephoto/CaptureShopPhoto')),
    path: '/capture-shop-photo',
    title: 'Capture Shop Photo',
  },
  [Pages.BODetails]: {
    component: configuredAsyncComponentLoader(() => import('pages/kyc/components/BOManagement')),
    path: '/bo-details',
    title: 'Beneficial Owner Details',
  },
  [Pages.VasServices]: {
    component: configuredAsyncComponentLoader(() => import('pages/vasServices')),
    path: '/VasServices',
    title: 'VAS Services',
  },
  [Pages.SelectVas]: {
    component: configuredAsyncComponentLoader(() => import('pages/vasServices/selectVases')),
    path: '/VasServices/select-vas',
    title: 'Select VAS',
  },
  [Pages.Vases]: {
    component: configuredAsyncComponentLoader(() => import('pages/vasServices/vases')),
    path: '/VasServices/vases',
    title: 'Vases',
  },
  [Pages.ViewExistingVas]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/vasServices/viewExistingVasServices'),
    ),
    path: '/VasServices/viewExistingVas',
    title: 'View Existing VAS',
  },
  [Pages.MapVas]: {
    component: configuredAsyncComponentLoader(() => import('pages/mapVas')),
    path: '/mapVas',
    title: 'Map VAS',
  },
  [Pages.MapVasDevices]: {
    component: configuredAsyncComponentLoader(() => import('pages/mapVas/mapDevices')),
    path: '/mapVas/mapDevices',
    title: 'Map VAS Devices',
  },
  [Pages.CSEL1Review]: {
    component: configuredAsyncComponentLoader(() => import('pages/cseL1InReview/CSEL1Review')),
    path: '/po/csel1-review',
    title: 'CSE L1 In Review',
  },
  [Pages.VasActivationRequested]: {
    component: configuredAsyncComponentLoader(() => import('pages/vasActivationRequested')),
    path: '/vasActivationRequested',
    title: 'VAS Activation Requested',
  },
  [Pages.NotificationProductDetail]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/mdrProduct/notificationDevices/productDetail'),
    ),
    path: '/PricingPlan/notificationProductDetail',
    title: 'Notification Product Detail',
  },
  [Pages.AccessoryProductDetail]: {
    component: configuredAsyncComponentLoader(
      () => import('pages/mdrProduct/accessoryProducts/productDetail/index'),
    ),
    path: '/PricingPlan/accessoryProductDetail',
    title: 'Accessory Product Detail',
  },
}

export default routes
